module.exports = __webpack_public_path__ + "static/10_Customer journey mapping_PO-Box.25dfadbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/10_Customer journey mapping_PO-Box.jpg
// module id = 484
// module chunks = 110568472390859